import { useMemo } from 'react';
import { useAppSelector } from '../../store/hooks';
import { getGradeColorFromPercentage, getGradeFromPercentage } from '../../utils/gradeUtils';

/** The school's grade bands, highest first, with lookups by percentage. */
export const useGradeScale = () => {
  const grades = useAppSelector((state) => state.grades.grades);
  return useMemo(() => ({
    bands: grades.filter((g) => g.isActive).sort((a, b) => b.minPercentage - a.minPercentage),
    color: (percentage: number) => getGradeColorFromPercentage(percentage, grades),
    letter: (percentage: number) => getGradeFromPercentage(percentage, grades),
  }), [grades]);
};

export type GradeScale = ReturnType<typeof useGradeScale>;
